import React, { useCallback } from 'react';
import { useRequests } from '../../contexts/RequestsContext';
import { binRequest } from '../../data/binRequest';
import { useCollecteConversation, type CollecteKind } from '../../hooks/useCollecteConversation';
import { AtnaDialogShell } from '../atna/AtnaDialogShell';
import { CollecteMessage } from './CollecteMessage';
interface CollecteDialogProps {
  initialText: string;
  onClose: () => void;
  /** Shared layout id: the launcher pill morphs into this panel. */
  layoutId: string;
}
export function CollecteDialog({
  initialText,
  onClose,
  layoutId
}: CollecteDialogProps) {
  const {
    addRequest
  } = useRequests();
  // Un bac toujours plein après le passage du camion devient une requête dans « Mes demandes ».
  const openRequest = useCallback(() => addRequest(binRequest), [addRequest]);
  const {
    turns,
    thinking,
    draft,
    setDraft,
    submitDraft,
    attachPhoto,
    photoAttached,
    confirmPickedUp,
    reportNotPickedUp,
    findNearestDropOff,
    passedAt,
    liveAtnaId,
    lastAtnaKind
  } = useCollecteConversation(initialText, openRequest);
  return <AtnaDialogShell layoutId={layoutId} subtitle="Collectes" onClose={onClose} turns={turns} thinking={thinking} liveAtnaId={liveAtnaId} footnote="ATNA peut se tromper. Le suivi en direct du camion est disponible dans la page Collectes." satisfaction={lastAtnaKind === 'bac-ok' || lastAtnaKind === 'requete-ouverte' || lastAtnaKind === 'batterie-lieux'} prompt={{
    value: draft,
    onChange: setDraft,
    onSubmit: submitDraft,
    onAddPhoto: attachPhoto,
    photoAttached,
    placeholder: lastAtnaKind === 'camion-passe' ? 'Répondre oui ou non…' : 'Poser une question sur votre collecte…'
  }} renderAtna={(kind, live) => <CollecteMessage kind={kind as CollecteKind} live={live} passedAt={passedAt} onConfirmPickedUp={confirmPickedUp} onReportNotPickedUp={reportNotPickedUp} onFindNearest={findNearestDropOff} data-id="element-848" data-mp="1eur7sgm8y9dr" />} data-id="element-847" data-mp="2lc6151tfcfv2" />;
}